import request from './request';

export function suggestions() {
    return request('get', '/apiv2/suggestions', {});
}

export function followSuggestionUser(id) {
    return request('post', `/apiv2/followers/${id}/follow`);
}

export function followSuggestionCampaign(data) {
    return request('post', '/apiv2/user/subscriptions/create', data);
}

export function followSuggestionCandidate(data) {
    return request('post', '/apiv2/user/subscriptions/create', data);
}